<template>
  <el-dialog
    v-if="visible"
    title="操作日志"
    :visible.sync="visible"
    width="80%"
    :append-to-body="true"
  >
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >

    </avue-crud>
  </el-dialog>

</template>
<script>


import {
  getOperateLogPage,
} from "@/api/v4ward/digitaltickets/feeitemtax/FeeItemTax.js";

export default {
  components: {

  },
  props: {
    feeTaxItemId:'',
    visible:false,

  },
  data() {
    return {
      data:[],
      title:'打印日志',
      option: {
        index: false,
        indexLabel: '序号',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'center',
        refreshBtn: false,
        viewBtn: false,
        searchBtn:false,
        columnBtn:false,
        searchShowBtn:false,
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '操作类型',
            width: 100,
            prop: 'operateType',
          },
          {
            label: '操作内容',
            prop: 'operateContent',
            // overHidden: true,
          },
          {
            label: '操作时间',
            width: 140,
            prop: 'operateTime',
          },
          {
            label: '操作人',
            width: 120,
            prop: 'operatorName',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
    };
  },
  watch:{
    visible(){
      this.$emit('update:visible',this.visible)
    }
  },
  created() {
  },
  methods: {
    handleClose(){},
    onLoad() {
      this.loading = true;
      if(this.feeTaxItemId){
        getOperateLogPage(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, {feeTaxItemId:this.feeTaxItemId})).then(({data})=>{
          this.data = data.records
          this.page.total = data.total
          this.loading = false;
        }).catch(()=>{
          this.loading = false;
        })
      }
    },
  },
};
</script>
<style>

</style>
